import type { ContextTabsProps } from "./context-tabs.type";

import { Tabs } from "antd";
import classNames from "classnames";

import { TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { useTabNavigation } from "@/hooks/use-tab-navigation";

export const ContextTabs = ({
  items,
  tabKey = TAB_PARAM_KEYS.CONTEXT_TAB_KEY,
  defaultActiveKey,
  className,
  paramsToKeep = [],
  tabBarExtraContent = undefined,
  alwaysSyncSearchParams = false,
  shouldSync,
  ...tabsProps
}: ContextTabsProps) => {
  const { visibleTabs, activeTabKey, onTabChange, location } = useTabNavigation(
    {
      items,
      tabKey,
      defaultActiveKey,
      paramsToKeep,
      alwaysSyncSearchParams,
      shouldSync,
    }
  );

  return (
    <div className={classNames("tabs-wrapper", className)}>
      <Tabs
        {...tabsProps}
        items={visibleTabs}
        defaultActiveKey={defaultActiveKey}
        key={location.pathname}
        activeKey={activeTabKey}
        onChange={onTabChange}
        tabBarExtraContent={tabBarExtraContent}
      />
    </div>
  );
};
